module.exports = __webpack_public_path__ + "img/personnel.ea6eca83.jpg";